import {
  ALERTS_CLEAR,
  ASSET_CREATE,
  ASSET_DELETE,
  ASSET_UPDATE,
  ASSET_COMMANDS_UPDATE,
  ASSET_MODEL,
  ASSET_MODEL_CREATE,
  ASSET_MODEL_READ,
  ASSET_MODEL_UPDATE,
  ASSET_MODEL_DELETE,
  BILLING,
  BILLING_WRITE,
  CORE,
  CORE_READ,
  DASHBOARD,
  DASHBOARD_CREATE,
  DASHBOARD_READ,
  DASHBOARD_UPDATE,
  DASHBOARD_DELETE,
  FLEET_CREATE,
  FLEET_DELETE,
  FLEET_REPORTS,
  FLEET_UPDATE,
  GATEWAY_VERSION_UPDATE,
  GEOFENCE,
  GEOFENCE_CREATE,
  GEOFENCE_DELETE,
  GEOFENCE_READ,
  GEOFENCE_UPDATE,
  MAINTENANCE,
  MAINTENANCE_LOG_CREATE,
  MAINTENANCE_MANAGE,
  MAINTENANCE_READ,
  MAINTENANCE_PARTS_CREATE,
  MAINTENANCE_PARTS_DELETE,
  MAINTENANCE_PARTS_UPDATE,
  MAINTENANCE_REMINDERS_CREATE,
  MAINTENANCE_REMINDERS_DELETE,
  MAINTENANCE_REMINDERS_UPDATE,
  MAINTENANCE_SCHEDULES_CREATE,
  MAINTENANCE_SCHEDULES_DELETE,
  MAINTENANCE_SCHEDULES_UPDATE,
  NON_PLATFORM_USER_SUBSCRIPTION,
  ORGANIZATION,
  ORGANIZATION_CREATE,
  ORGANIZATION_READ,
  ORGANIZATION_UPDATE,
  ORGANIZATION_DELETE,
  ORGANIZATION_MOVE,
  OUTPUTSIGNAL_CREATE,
  OUTPUTSIGNAL_DELETE,
  OUTPUTSIGNAL_UPDATE,
  PROVISION,
  PROVISION_CREATE,
  PROVISION_DELETE,
  PROVISION_READ,
  PROVISION_UPDATE,
  REMOTE,
  REMOTE_CREATE,
  REMOTE_DELETE,
  REMOTE_EXECUTE,
  REMOTE_READ,
  REMOTE_UPDATE,
  REPORT,
  REPORT_CREATE,
  REPORT_DELETE,
  REPORT_READ,
  REPORT_SCHEDULE,
  REPORT_UPDATE,
  RULE_CONDITIONS_CREATE,
  RULE_CONDITIONS_DELETE,
  RULE_CONDITIONS_UPDATE,
  RULE_SUBSCRIPTION_USERS,
  RULES_CREATE,
  RULES_DELETE,
  RULES_UPDATE,
  SIGNAL_CARDS_UPDATE,
  SIGNAL_COLLECTIONS_CREATE,
  SIGNAL_COLLECTIONS_DELETE,
  SIGNAL_COLLECTIONS_UPDATE,
  TRANSFORMS_CREATE,
  TRANSFORMS_DELETE,
  TRANSFORMS_UPDATE,
  USER,
  USER_CREATE,
  USER_READ,
  USER_UPDATE,
  USER_DELETE,
  USER_PERMISSION,
  USER_PERMISSION_CREATE,
  USER_PERMISSION_READ,
  USER_PERMISSION_UPDATE,
  USER_PERMISSION_DELETE,
  USER_PROFILE_CREATE,
  USER_PROFILE_READ,
  USER_PROFILE_UPDATE,
  USER_PROFILE_DELETE,
  USER_COMMANDS_UPDATE,
  WATERTRANSFER_CREATE,
  WATERTRANSFER_DELETE,
  WATERTRANSFER_UPDATE,
  WIDGET_CREATE,
  WIDGET_DELETE,
  WIDGET_UPDATE,
  WIDGET_GRID_UPDATE,
} from '../Constants/RBAC';

export const rulesV2 = new Map([
  [
    1,
    new Map([
      [ASSET_MODEL, new Set([ASSET_MODEL_READ])],
      [CORE, new Set([CORE_READ])],
      [DASHBOARD, new Set([DASHBOARD_READ])],
      [GEOFENCE, new Set([GEOFENCE_READ])],
      [MAINTENANCE, new Set([MAINTENANCE_READ])],
      [ORGANIZATION, new Set([ORGANIZATION_READ])],
      [PROVISION, new Set([PROVISION_READ])],
      [REMOTE, new Set([REMOTE_READ])],
      [REPORT, new Set([REPORT_READ])],
      [USER, new Set([USER_READ, USER_PROFILE_READ])],
      [USER_PERMISSION, new Set([USER_PERMISSION_READ, USER_PROFILE_READ])],
    ]),
  ],
  [
    2,
    new Map([
      [
        ASSET_MODEL,
        new Set([
          ASSET_MODEL_READ,
          ASSET_MODEL_CREATE,
          ASSET_MODEL_UPDATE,
          ASSET_MODEL_DELETE,
          OUTPUTSIGNAL_CREATE,
          OUTPUTSIGNAL_DELETE,
          OUTPUTSIGNAL_UPDATE,
          RULES_CREATE,
          RULES_UPDATE,
          RULES_DELETE,
          RULE_CONDITIONS_CREATE,
          RULE_CONDITIONS_UPDATE,
          RULE_CONDITIONS_DELETE,
          SIGNAL_CARDS_UPDATE,
          SIGNAL_COLLECTIONS_CREATE,
          SIGNAL_COLLECTIONS_UPDATE,
          SIGNAL_COLLECTIONS_DELETE,
          TRANSFORMS_CREATE,
          TRANSFORMS_UPDATE,
          TRANSFORMS_DELETE,
        ]),
      ],
      [BILLING, new Set([BILLING_WRITE])],
      [
        CORE,
        new Set([
          ALERTS_CLEAR,
          ASSET_CREATE,
          ASSET_UPDATE,
          ASSET_DELETE,
          CORE_READ,
          WATERTRANSFER_CREATE,
          WATERTRANSFER_DELETE,
          WATERTRANSFER_UPDATE,
        ]),
      ],
      [
        DASHBOARD,
        new Set([
          DASHBOARD_CREATE,
          DASHBOARD_READ,
          DASHBOARD_UPDATE,
          DASHBOARD_DELETE,
          WIDGET_CREATE,
          WIDGET_DELETE,
          WIDGET_UPDATE,
          WIDGET_GRID_UPDATE,
        ]),
      ],
      [
        GEOFENCE,
        new Set([
          GEOFENCE_READ,
          GEOFENCE_CREATE,
          GEOFENCE_UPDATE,
          GEOFENCE_DELETE,
        ]),
      ],
      [
        MAINTENANCE,
        new Set([
          MAINTENANCE_READ,
          MAINTENANCE_LOG_CREATE,
          MAINTENANCE_PARTS_CREATE,
          MAINTENANCE_PARTS_DELETE,
          MAINTENANCE_PARTS_UPDATE,
          MAINTENANCE_REMINDERS_CREATE,
          MAINTENANCE_REMINDERS_UPDATE,
          MAINTENANCE_REMINDERS_DELETE,
          MAINTENANCE_SCHEDULES_CREATE,
          MAINTENANCE_SCHEDULES_UPDATE,
          MAINTENANCE_SCHEDULES_DELETE,
        ]),
      ],
      [
        ORGANIZATION,
        new Set([
          ORGANIZATION_CREATE,
          ORGANIZATION_READ,
          ORGANIZATION_UPDATE,
          ORGANIZATION_DELETE,
          ORGANIZATION_MOVE,
        ]),
      ],
      [
        PROVISION,
        new Set([
          ASSET_CREATE,
          PROVISION_READ,
          PROVISION_CREATE,
          PROVISION_UPDATE,
          PROVISION_DELETE,
        ]),
      ],
      [
        REMOTE,
        new Set([
          ASSET_COMMANDS_UPDATE,
          REMOTE_READ,
          REMOTE_CREATE,
          REMOTE_UPDATE,
          REMOTE_DELETE,
          REMOTE_EXECUTE,
          GATEWAY_VERSION_UPDATE,
          USER_COMMANDS_UPDATE,
        ]),
      ],
      [
        REPORT,
        new Set([
          FLEET_CREATE,
          FLEET_UPDATE,
          FLEET_DELETE,
          FLEET_REPORTS,
          REPORT_READ,
          REPORT_CREATE,
          REPORT_DELETE,
          REPORT_UPDATE,
          REPORT_SCHEDULE,
        ]),
      ],
      [
        USER,
        new Set([
          NON_PLATFORM_USER_SUBSCRIPTION,
          RULE_SUBSCRIPTION_USERS,
          USER_READ,
          USER_CREATE,
          USER_UPDATE,
          USER_DELETE,
        ]),
      ],
      [
        USER_PERMISSION,
        new Set([
          USER_PERMISSION_READ,
          USER_PERMISSION_CREATE,
          USER_PERMISSION_UPDATE,
          USER_PERMISSION_DELETE,
          USER_PROFILE_READ,
          USER_PROFILE_CREATE,
          USER_PROFILE_UPDATE,
          USER_PROFILE_DELETE,
        ]),
      ],
    ]),
  ],
  [
    3,
    new Map([
      [
        MAINTENANCE,
        new Set([
          MAINTENANCE_LOG_CREATE,
          MAINTENANCE_MANAGE,
          MAINTENANCE_READ,
          MAINTENANCE_REMINDERS_CREATE,
          MAINTENANCE_REMINDERS_UPDATE,
          MAINTENANCE_REMINDERS_DELETE,
        ]),
      ],
    ]),
  ],
]);
